import React, { useEffect, useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import authApi from '../../api/authApi';
import './Register.css';
import { useDispatch } from 'react-redux';
import { setEmailRegister } from './registerSlice';
import { setUserEmail, setUserId } from '../Login/loginSlice';

const Register = () => {
    const [email, setEmail] = useState('');
    const [code, setCode] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [step, setStep] = useState('email');
    const [isCooldown, setIsCooldown] = useState(false);
    const [cooldownTime, setCooldownTime] = useState(60);

    const [agreement1, setAgreement1] = useState(false);
    const [agreement2, setAgreement2] = useState(false);

    const [referralId, setReferralId] = useState(null);
    const [searchParams] = useSearchParams();

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const   handleEmailSubmit = async () => {
        // navigate('/payment')
        try {
            const response = await authApi.register(email, referralId);

            if (response.data.status === 'success') {
                setStep('code');
                setIsCooldown(true)
                setCooldownTime(60)

            } else {
                alert(response.data.error);
            }
        } catch (error) {
            console.error('Ошибка во время регистрации:', error);
            alert('Произошла ошибка при отправке email.');
        }
    };

    useEffect(() => {
        if (!isCooldown) return;

        const timer = setInterval(() => {
            setCooldownTime((prevTime) => {
                if (prevTime <= 1) {
                    clearInterval(timer);
                    setIsCooldown(false);
                    return 0;
                }
                return prevTime - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [isCooldown]);

    const handleCodeSubmit = async () => {
        try {
            const response = await authApi.verifyCode(email, code);
            if (response.data.status === 'success') {
                dispatch(setEmailRegister(email))
                setStep('password');
            } else {
                alert(response.data.error);
            }
        } catch (error) {
            console.error('Ошибка во время проверки кода:', error);
            alert('Произошла ошибка при проверке кода.');
        }
    };

    const handlePasswordSubmit = async () => {
        try {
            const response = await authApi.verifyPassword(email, password, referralId);
            if (response.data.status === 'success') {
                navigate('/login')
                // dispatch(setUserEmail(email))
                // alert(`userId ${response.data.user_id}`);
                // dispatch(setUserId(response.data.user_id))
                // navigate('/payment')
            } else {
                alert(response.data.error);
            }
        } catch (error) {
            console.error('Ошибка во время проверки кода:', error);
            alert('Произошла ошибка при проверке пароля.');
        }
    };

    const handleRefreshCode = async () => {
        if (isCooldown) return; // Блокируем отправку, если таймер активен

        try {
            const response = await authApi.register(email, referralId);
            if (response.data.status === 'success') {
                alert('Код повторно отправлен. Проверьте почту.');
                setIsCooldown(true);
                setCooldownTime(60); // Перезапускаем таймер
            } else {
                alert(response.data.error);
            }
        } catch (error) {
            console.error('Ошибка при повторной отправке кода:', error);
            alert('Произошла ошибка при повторной отправке кода.');
        }
    };

    const isPasswordValid = (password) => {
        const hasUpperCase = /[A-Z]/.test(password);
        const hasLowerCase = /[a-z]/.test(password);
        const hasDigit = /\d/.test(password);
        const hasSpecialChar = /[^a-zA-Z\d]/.test(password);
        const compare = password === confirmPassword && confirmPassword !== ''
        return hasUpperCase && hasLowerCase && hasDigit && hasSpecialChar && compare;
    };


    useEffect(() => {
        const ref = searchParams.get('ref');
        // console.log('ref', ref)
        if (ref) {
            setReferralId(ref);
        }
    }, [searchParams]);

    return (
        <div className="register-container">
            <div className="register-form">
                <h2>Регистрация</h2>

                {step === 'email' ? (
                    <>
                        <div className="mb-3">
                            <label htmlFor="email"><strong>Email</strong></label>
                            <input
                                type="email"
                                placeholder="Введите Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className='reg_input'
                            />
                        </div>
                        <div className="agreement-container">
                            <div className="styled-checkbox">
                                <div className='cntr_checkbox' style={{ width: '35px' }}>
                                    <input
                                        type="checkbox"
                                        id="agreement1"
                                        checked={agreement1}
                                        onChange={(e) => setAgreement1(e.target.checked)}
                                    />
                                </div>

                                <label className='mini_text' htmlFor="agreement1">Даю <a href="https://bottax.tech/pii_agree/">Согласие</a> на обработку персональных данных<br />
                                </label>
                            </div>
                        </div>
                        <div className="agreement-container">
                            <div className="styled-checkbox">
                                <div className='cntr_checkbox' style={{ width: '35px' }}>
                                    <input
                                        type="checkbox"
                                        id="agreement2"
                                        checked={agreement2}
                                        onChange={(e) => setAgreement2(e.target.checked)}
                                    />
                                </div>
                                {/* <label className='mini_text' htmlFor="agreement2">Принимаю <a href="https://bottax.tech/policy/">Политику обработки</a> персональных данных </label> */}
                                <label className='mini_text' htmlFor="agreement2">Принимаю <a href="https://bottax.tech/agreement/">Пользовательское соглашение</a></label>
                            </div>
                        </div>

                        <button
                            className={`register_button ${!agreement1 || !agreement2 ? '' : ''}`}
                            onClick={handleEmailSubmit}
                            disabled={!agreement1 || !agreement2}
                        >
                            Отправить
                        </button>
                        <Link to="/login" className="btn-back">
                            Назад к входу
                        </Link>
                    </>
                ) : step === 'code' ? (
                    <>
                        <div className="mb-3">
                            <label style={{ textAlign: 'center' }} htmlFor="code"><strong>Вам на почту отправлен код, введите его в поле</strong></label>
                            <input
                                type="text"
                                placeholder="Введите код"
                                value={code}
                                onChange={(e) => setCode(e.target.value)}
                                className="form-control"
                            />
                        </div>
                        <button
                            className="register_button"
                            onClick={handleCodeSubmit}
                        >
                            Ок
                        </button>
                        <p className="cooldown-message">
                            {isCooldown
                                ? `Код был отправлен. Не забудьте проверить папку спам. Вы можете повторно запросить через ${cooldownTime} секунд.`
                                : 'Код не пришел?'}
                        </p>
                        <button
                            className="forgot_button"
                            onClick={handleRefreshCode}
                            disabled={isCooldown}
                        >
                            Повторно отправить код
                        </button>
                    </>
                ) : step === 'password' ? (
                    <>
                        <div className="mb-1">
                            <label htmlFor="password"><strong>Пароль</strong></label>
                            <input
                                type="password"
                                placeholder="Введите пароль"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="form-control"
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="confirmPassword"><strong>Подтвердите пароль</strong></label>
                            <input
                                type="password"
                                id="confirmPassword"
                                placeholder="Повторите пароль"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                className="form-control"
                            />
                        </div>
                        <ul className="password-requirements">
                            <li className={password.match(/[A-Z]/) ? "valid" : "invalid"}>
                                Большая буква (A-Z)
                            </li>
                            <li className={password.match(/[a-z]/) ? "valid" : "invalid"}>
                                Маленькая буква (a-z)
                            </li>
                            <li className={password.match(/\d/) ? "valid" : "invalid"}>
                                Хотя бы одна цифра (0-9)
                            </li>
                            <li className={password.match(/[^a-zA-Z\d]/) ? "valid" : "invalid"}>
                                Специальный символ (!@#$%^&*)
                            </li>
                            <li className={password === confirmPassword && confirmPassword !== '' ? "valid" : "invalid"}>
                                Пароли совпадают
                            </li>
                        </ul>
                        <button
                            className="register_button"
                            onClick={handlePasswordSubmit}
                            disabled={!isPasswordValid(password)}
                        > Установить пароль
                        </button>
                    </>
                ) : null
                }
            </div>
        </div>
    );
};

export default Register;
